import { Stack, styled } from "@mui/material";

export const Wrapper = styled(Stack)`
  flex: 1;
`;
